import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getRoleDetail } from "redux/actions/Master";
import { AppState } from "redux/store";
import { RoleData as MasterRoleData } from "types/models/master/MasterApp";
import RoleCreate from "../RoleCreate";
import RoleHeader from "../RoleCreate/roleHeader";
import RoleUpdate from "./roleUpdate";

const RoleUpdatIndex: React.FC = () => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id?: string }>() || {};
  const { currentRole } = useSelector<AppState, AppState["master"]>(
    ({ master }) => master
  );

  useEffect(() => {

    if (id !== undefined) {
      setTimeout(() => {
        dispatch(getRoleDetail(id));
      }, 1);
    }
  }, [dispatch, id]);

  return (
    <>
      <AppAnimate animation="transition.slideUpIn" delay={200}>
        <AppCard>
          {currentRole ? (
            <>
              <RoleHeader role={currentRole as MasterRoleData} />
              <AppGridContainer>
                <RoleUpdate Role={currentRole as MasterRoleData} />
              </AppGridContainer>
            </>
          ) : (
            <p>Loading...</p> 
          )}
        </AppCard>
      </AppAnimate>
      <AppInfoView />
    </>
  );
};

export default RoleUpdatIndex;
